import {ADD_ALARM, DELETE_ALARM, FETCH_ALARMS, FETCH_EXCHANGES, FETCH_STOCKS, RESET_STOCKS} from "./actions.type";
import {AlarmsService, StocksService} from "@/common/api.service";
import {SET_ALARMS, SET_EXCHANGES, SET_STOCKS} from "./mutations.type";

const state = {
    alarms: [],
    alarmsCount: 0,
    exchanges: [],
    stocks: []
};

const getters = {
    alarms() {
        return state.alarms;
    },
    alarmsCount() {
        return state.alarmsCount;
    },
    exchanges() {
        return state.exchanges;
    },
    stocks() {
        return state.stocks;
    }
};

const actions = {
    [FETCH_ALARMS](context) {
        return AlarmsService.listAlarms()
            .then(({data}) => {
                context.commit(SET_ALARMS, data);
                return data;
            })
            .catch(() => {
                throw new Error("Unable to fetch and set alarms")
            });
    },
    [FETCH_EXCHANGES](context) {
        return StocksService.listExchanges()
            .then(({data}) => {
                context.commit(SET_EXCHANGES, data.exchanges);
                return data;
            })
            .catch(() => {
                throw new Error("Unable to fetch exchanges")
            });
    },
    [FETCH_STOCKS](context, exchangeId) {
        return StocksService.listStocksForExchange(exchangeId)
            .then(({data}) => {
                context.commit(SET_STOCKS, data.stocks);
                return data;
            })
            .catch(() => {
                throw new Error("Unable to fetch stocks")
            });
    },
    [RESET_STOCKS](context) {
        context.commit(RESET_STOCKS);
    },
    [ADD_ALARM](context, payload) {
        return AlarmsService.addAlarm("", payload)
            .then(() => {
                context.dispatch(FETCH_ALARMS);
            })
            .catch(() => {
                throw new Error("unable to add alarm");
            });
    },
    [DELETE_ALARM](context, id) {
        return AlarmsService.deleteAlarm("", id)
            .then(() => {
                context.dispatch(FETCH_ALARMS);
            })
            .catch(() => {
                throw new Error("unable to delete alarm");
            });
    }
};

const mutations = {
    [SET_ALARMS](state, alarms) {
        state.alarms = alarms.alarms;
        state.alarmsCount = alarms.alarms.length
    },
    [SET_EXCHANGES](state, exchanges) {
        state.exchanges = exchanges;
    },
    [SET_STOCKS](state, stocks) {
        state.stocks = stocks;
    },
    [RESET_STOCKS](state) {
        state.stocks = [];
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
